<fui-text-control [disabled]="isReadonly" [label]="label" [placeholder]="placeholder" [attr.id]="elementId"
                  [(ngModel)]="value" [notation]="notation" [control]="formControl" >
</fui-text-control>
